export const NAV_ITEMS = [
  {
    label: 'Businesses',
    href: '/directory',
    matches: (pathname) => pathname === '/directory' || pathname.startsWith('/business/'),
  },
  {
    label: 'Deals',
    href: '/deals',
    matches: (pathname) => pathname === '/deals',
  },
  {
    label: 'Advertise With Us!',
    href: '/advertise/spotlight',
    children: [
      { label: 'Spotlight Online', href: '/advertise/spotlight' },
      { label: 'Monthly Mailer', href: '/advertise/mailer' },
    ],
    matches: (pathname) => pathname === '/advertise/spotlight' || pathname === '/advertise/mailer',
  },
  {
    label: 'Events',
    href: '/events',
    matches: (pathname) => pathname === '/events',
  },
  {
    label: 'Articles',
    href: '/articles',
    matches: (pathname) => pathname === '/articles',
  },
  {
    label: 'About',
    href: '/about',
    matches: (pathname) => pathname === '/about',
  },
];
